<template>
  <div class="transport-directory-main">
    <div class="setting" v-if="false">
      <ul>
        <li>
          <div class="setting-item">
            <div class="name ellispsis">{{ $t("page_docdirectory_jurisdiction_open_auth") }}</div>
            <div class="rule ellispsis">{{ $t("page_docdirectory_jurisdiction_open_auth_tips") }}</div>
          </div>
          <a-switch :checked="limit" @change="onChange" v-acl="'page_docdirectory_switch'" />
        </li>
      </ul>
    </div>
    <div class="content">
      <div class="tree-panel">
        <tree-expand
          ref="tree"
          :treeProps="treeProps"
          :menus="showMenus"
          @rename="updateMenu"
          :treeEvents="{ select: onSelect }"
        ></tree-expand>
      </div>
      <div class="con-main">
        <a-alert
          :message="$t('page_docdirectory_jurisdiction_edit_tips')"
          type="info"
          showIcon
          style="margin-bottom:20px"
        />
        <div class="title">{{ $t("page_docdirectory_jurisdiction_auth") }}</div>
        <div>
          <div
            style="padding-left:70px;margin-bottom:20px;"
          >{{ $t("page_docdirectory_current_node") }} {{ chooseItem }}</div>
          <div class="select-wrapper">
            <div>{{ $t("page_docdirectory_jurisdiction_auth") }}:</div>
            <a-tree-select
              labelInValue
              allowClear
              class="select"
              show-search
              tree-node-filter-prop="title"
              v-model="chooseAuthority"
              :placeholder="$t('please_select') + $t('page_docdirectory_jurisdiction_auth')"
              :treeData="authorityList"
              :disabled="!edit_mode"
            />
            <a-button
              v-if="!edit_mode"
              class="select-after-btn"
              type="primary"
              :disabled="!selects || !selects[0]  || selects == 0"
              @click="() => (edit_mode = true)"
              v-acl="'page_docdirectory_save'"
            >{{ $t("page_docdirectory_jurisdiction_change_auth") }}</a-button>
            <a-button
              v-else
              class="select-after-btn"
              type="primary"
              :disabled="canSave"
              @click="onSave"
              v-acl="'page_docdirectory_save'"
            >{{ $t("save") }}</a-button>
          </div>
        </div>
      </div>
    </div>
    <a-modal
      :title="$t('page_docdirectory_add_submenu')"
      :cancelText="$t('cancel')"
      :okText="$t('save')"
      :visible="visible"
      @ok="saveMenu"
      :maskClosable="false"

      @cancel="visible = false"
    >
      <div class="modal-content">
        <span>{{ $t("page_docdirectory_name") }}:</span>
        <a-input v-model="inputValue" :maxLength="30"></a-input>
      </div>
    </a-modal>
  </div>
</template>

<script>
import Vue from "vue";
import TreeExpand from "@/components/TreeExpand";
import { AuthorityDomainServiceProxy } from "@/service-proxies/app-v2/system.service-proxies";
import { ManageDirectoryServiceProxy } from "@/service-proxies/app-v2/dnc.service-proxies";
const serviceProxy = new ManageDirectoryServiceProxy();
const authorityServiceProxy = new AuthorityDomainServiceProxy();

const normalizeArrayChildren = children => {
  const res = [];
  children.map(child => {
    res.push(child);
    if (child.children && child.children.length > 0) {
      const c = normalizeArrayChildren(child.children);
      res.push(...c);
    }
  });
  return res;
};

const recursionHelper = items => {
  items.forEach(d => {
    d.scopedSlots = { title: "custom" };
    if (d.children && d.children.length > 0)
      d.children = recursionHelper(d.children);
  });
  return items;
};

const authorityListHelper = items => {
  const res = [];
  items.map(d => {
    const item = {
      key: d.id,
      value: d.id,
      title: d.title
    };
    if (d.children && d.children.length > 0)
      item.children = authorityListHelper(d.children);
    res.push(item);
  });
  return res;
};

export default Vue.extend({
  components: {
    TreeExpand
  },
  data() {
    return {
      edit_mode: false,
      normalizeData: [],
      selects: ["0"],
      chooseAuthority: null,
      authorityList: [],
      context: {},
      inputValue: "",
      visible: false,
      limit: false,
      showAddModal: false,
      menus: [
        {
          acl: "page_docdirectory_append",
          title: "page_docdirectory_add_submenu",
          on: {
            click: this.addMenu
          }
        },
        {
          acl: "page_docdirectory_rename",
          title: "page_docdirectory_rename",
          on: {
            click: this.renameMenu
          }
        },
        {
          acl: "page_docdirectory_delete",
          title: "delete",
          on: {
            click: this.deleteMenu
          }
        }
      ],
      treeProps: {
        replaceFields: {
          key: "id"
        },
        defaultSelectedKeys: ["0"],
        treeData: []
      }
    };
  },
  computed: {
    canSave() {
      return !(
        /*this.chooseAuthority &&*/
        (this.selects && this.selects.length > 0 && this.selects[0] != "0")
      );
    },
    showMenus() {
      const buttons = this.$store.getters.buttons;
      return this.menus.filter(item => buttons.includes(item.acl));
    },
    chooseItem() {
      const id = Number(this.selects[0]);
      const data = this.normalizeData;
      if (!id) return this.$t("page_docdirectory_manage_menu");
      const find = data.find(d => d.id == id);
      const allPath = find.data.allPath;
      const split = allPath.split("/").slice(2);
      const show = split.reduce(
        (s, id) => `${s}/${data.find(d => d.id == id).title}`,
        this.$t("page_docdirectory_manage_menu")
      );
      return show;
    }
  },
  mounted() {
    this.getTree();
    this.getAuthorityList();
  },
  methods: {
    reset() {
      this.selects = ["0"];
      this.chooseAuthority = null;
    },
    onSelect(selects) {
      this.edit_mode = false;
      this.selects = selects;
      const rule = `.*("data":{.*?"id":"${selects[0]}".*?})`;
      const reg = new RegExp(rule);
      const str = JSON.stringify(this.treeProps.treeData[0].children);
      let find = reg.exec(str);
      if (!find) return (this.chooseAuthority = null);
      find = JSON.parse(find[find.length - 1].substr(7));
      const authorityId = find.authorityId || null;
      console.log("authorityId", authorityId);
      if (!authorityId) {
        this.chooseAuthority = null;
        return;
      }
      authorityServiceProxy.findNameValueById(authorityId).then(nameValue => {
        this.chooseAuthority = {
          value: nameValue.name,
          label: nameValue.value
        }; // nameValue.value;
      });
    },
    async getAuthorityList() {
      const { data } = await authorityServiceProxy.getEnableTreeList();
      const res = authorityListHelper(data);
      this.authorityList = res;
    },
    async getTree() {
      const data = await serviceProxy.treeList(1);
      const normalizeData = normalizeArrayChildren(data);
      this.normalizeData = normalizeData;
      recursionHelper(data);
      this.treeProps.treeData = [
        {
          title: this.$t("page_docdirectory_manage_menu"),
          id: "0",
          scopedSlots: { title: "custom" },
          excludes: [this.$t("page_docdirectory_rename"), this.$t("delete")],
          children: data
        }
      ];
      this.treeProps.defaultSelectedKeys = this.selects || ["0"];
    },
    addMenu(context) {
      this.context = context;
      this.inputValue = "";
      this.visible = true;
    },
    async saveMenu() {
      if (!this.inputValue)
        return this.$message.error(
          this.$t("page_docdirectory_name_empty") + "!"
        );

      const data = {
        authorityId: null,
        name: this.inputValue,
        parentAllPath: (this.context.data && this.context.data.allPath) || "/0",
        parentId: this.context.id,
        isSetting: 1
      };

      await serviceProxy.save(data);
      this.$message.success(this.$t("page_docdirectory_create_success"));
      this.visible = false;
      this.getTree();
      // this.reset();
    },
    renameMenu(context) {
      this.$refs.tree.onRename(context);
    },
    async onSave() {
      const context = {
        id: this.selects[0],
        authorityId: this.chooseAuthority ? this.chooseAuthority.value : null,
        isSetting: 1
      };
      await serviceProxy.update(context);
      this.$message.success(this.$t("page_docdirectory_save_scccess"));
      this.getTree();
      this.edit_mode = false;
    },
    async updateMenu(value, context) {
      await serviceProxy.update(context);
      this.$message.success(this.$t("page_docdirectory_edit_success"));
      this.getTree();
      // this.reset();
    },
    async deleteMenu(context) {
      await serviceProxy.delete(context.id);
      this.$message.success(this.$t("page_docdirectory_delete_success"));
      this.getTree();
      this.reset();
    },
    onChange(checked) {
      this.limit = checked;
    },
    openAddModal() {
      this.showAddModal = true;
    }
  }
});
</script>

<style scoped lang="less">
.transport-directory-main {
  height: calc(100% - 41px);

  .setting {
    ul {
      padding-left: 0;

      li {
        height: 65px;
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        border-bottom: 1px solid #e8e8e8;
        padding: 16px 0;

        .setting-item {
          width: 80%;

          .name,
          .rule {
            width: 100%;
            line-height: 22px;
            color: rgba(0, 0, 0, 0.65);
          }

          .rule {
            color: rgba(0, 0, 0, 0.25);
          }
        }

        button {
          margin: 5px 0;
        }
      }
    }
  }

  .content {
    height: calc(100% - 16px);
    display: flex;

    .tree-panel {
      width: 295px;
      height: 100%;
      overflow: auto;
      background-color: #f8f8f8;

      .right-drop-down {
        display: none;
        margin-right: 10px;
        float: right;
      }

      /deep/ .ant-tree-treenode-selected > span .right-drop-down {
        display: block !important;
      }
    }

    .con-main {
      width: calc(100% - 312px);
      margin-left: 8px;
      padding-left: 8px;
      height: 100%;
      border-left: 1px solid #e8e8e8;
      color: rgba(0,0,0,.85);

      .title {
        padding: 0 8px;
        border-left: 3px solid #3a7fbc;
        color: #3a7fbc;
        overflow: hidden;
        margin-bottom: 16px;
      }

      .select-wrapper {
        display: flex;
        align-items: center;

        > div:first-child {
          padding-right: 10px;
          flex-basis: 140px;
          text-align: right;
        }
        .select {
          flex-basis: 324px;
          // /deep/ .ant-select-selection {
          //   border-radius: 4px 0 0 4px;
          // }
        }

        .select-after-btn {
          border-left: none;
          // border-radius: 0 4px 4px 0;
        }
      }
    }
  }
}

.modal-content {
  display: flex;
  align-items: center;

  > span {
    width: 120px;
    padding-right: 10px;
    text-align: right;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);

    &:before {
      display: inline-block;
      margin-right: 4px;
      color: #f5222d;
      font-size: 14px;
      font-family: SimSun, sans-serif;
      line-height: 1;
      content: "*";
    }
  }
}
</style>
